import React, { useEffect, useState } from 'react';
import { CardBody, NavItem, TabContent, TabPane, Button, Form, Row, Col, Label, Input, FormGroup } from 'reactstrap';

import { Link, NavLink } from 'react-router-dom';
import { basicFieldsCR, basicFieldsSH, formHeaderCR, formHeaderSH, FormState, navItems } from './constants';
import TableConfigFields from './tableConfig';
import Switch from 'react-switch';
import PreviewTemplate from './previewTemplate';
import { useDispatch, useSelector } from 'react-redux';
import { getConfigPOD, saveConfigPOD } from '../../store/actions';
import './configPOD.scss';
const initialState: FormState = {
    OperationType: '',
    ShipmentType: '',
    ShowLogo: false,
    ShowPODtext: false,
    Signature_Required: false,
    Consignee_DisplayText: '',
    Consignee_Visible: false,
    ReleasedTo_DisplayText: '',
    ReleasedTo_Visible: false,
    DriverName_DisplayText: '',
    DriverName_Visible: false,
    ArrayBody: [],
    ArrayTable: [],
    Footer: '',

};

const ConfigReportPODForm = () => {
    const { configPODData } = useSelector((state: any) => state.ConfigPOD);
    const dispatch = useDispatch();
    const [activeTab, setactiveTab] = useState(1);
    const [formState, setFormState] = useState<FormState>(initialState);
    const [arrayFormHeader, setArrayFormHeader] = useState<any>([]);
    const handleInputChange = (updatedValue: Partial<FormState>) => {
        setFormState((prevState) => ({
            ...prevState,
            ...updatedValue,
        }));
    };
    function toggleTab(tab: any) {
        if (activeTab !== tab) {
            setactiveTab(tab);
        }
    }
    const handleButtonChange = (type: string) => {
        handleInputChange({ OperationType: type });
        setactiveTab(2);
    };
    const handleSaveConfig = () => {
        dispatch(saveConfigPOD(formState));
    };

    const filterClassnames = (item: any) => {
        if (activeTab === item.id || activeTab === 1) return 'nav-link disabled';
        if (activeTab === item.id) return 'nav-link';
        return '';
    };

    useEffect(() => {
        if (formState.OperationType) {
            dispatch(getConfigPOD({ OperationType: formState.OperationType }));
            if (formState.OperationType === 'SH') setArrayFormHeader(formHeaderSH);
            if (formState.OperationType === 'CR') setArrayFormHeader(formHeaderCR);
        }
    }, [formState.OperationType]);

    useEffect(() => {        
        if (configPODData && Object.keys(configPODData).length > 0) {
            configPODData.Footer = configPODData.Footer.replace(/\n/g, '\\n');
            setFormState(configPODData);
        } else {
            const { OperationType, ...restOfInitialState } = initialState;
            const basicFields = formState.OperationType === 'SH' ? basicFieldsSH : formState.OperationType === 'CR' ? basicFieldsCR : null;
            if (basicFields) {
                setFormState({
                    ...restOfInitialState,
                    OperationType: formState.OperationType,
                    ArrayBody: basicFields.ArrayBody,
                    ArrayTable: basicFields.ArrayTable,
                });
            }
        }
    }, [configPODData]);

    return (
        <React.Fragment>
            <CardBody>
                <div id="basic-pills-wizard" className="twitter-bs-wizard" style={{ marginTop: '100px' }}>
                    <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified">
                        {navItems.map((item: any) => (
                            <NavItem key={item.id}>
                                <NavLink to="#" className={filterClassnames(item)} onClick={() => setactiveTab(item.id)}>
                                    <div className="step-icon" data-bs-toggle="tooltip" data-bs-placement="top" title={item.title}>
                                        <i className={item.iconClass}></i>
                                    </div>
                                </NavLink>
                            </NavItem>
                        ))}
                    </ul>
                    <TabContent className="twitter-bs-wizard-tab-content" activeTab={activeTab}>
                        <TabPane tabId={1} className='tab-pane-border'>
                            <div className="text-center mb-4">
                                <h5>Operation Type Report POD</h5>
                                <p className="card-title-desc">Choose the type of operation to access the respective report configuration</p>
                            </div>
                            <div className="d-flex justify-content-center mb-5">
                                <Button size="lg" className="mx-2 button-primaryColor" onClick={() => handleButtonChange('CR')}>
                                    Cargo Release POD
                                </Button>
                                <Button size="lg" className="mx-2 button-primaryColor" onClick={() => handleButtonChange('SH')}>
                                    Shipment POD
                                </Button>
                            </div>
                        </TabPane>
                        <TabPane tabId={2}>
                            <div className="text-center mb-4">
                                <h5>Header Report POD</h5>
                                <p className="card-title-desc">
                                    In this section you can configure the fields that are displayed in the report header.
                                </p>
                            </div>
                            <Form>
                                <div className="border p-4 rounded">
                                    <Row>
                                        {arrayFormHeader.map((field: any, index: any) => (
                                            <Col md={6} xs={12} className="text-center mb-4 border p-4 rounded" key={index}>
                                                <FormGroup className="mb-3">
                                                    <Label for={field.key} className="form-label d-block mb-2">
                                                        {field.label}
                                                    </Label>
                                                    {field.type === 'input' ? (
                                                        <Input
                                                            type="text"
                                                            id={field.key}
                                                            name={field.key}
                                                            className="text-center"
                                                            value={formState[field.key as keyof FormState] as string}
                                                            onChange={(e: any) => handleInputChange({ [field.key]: e.target.value })}
                                                            style={{ margin: '0 auto', maxWidth: '500px' }}
                                                        />
                                                    ) : (
                                                        <div className="d-flex justify-content-center">
                                                            <Switch
                                                                checked={formState[field.key as keyof FormState] as boolean}
                                                                onChange={(checked: boolean) => handleInputChange({ [field.key]: checked })}
                                                                id={field.key}
                                                            />
                                                        </div>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                        ))}

                                        {formState.OperationType === 'SH' && (

                                            <Col md={6} xs={12} className="text-center mb-4 border p-4 rounded">
                                                <Label for="shipmentTypeSelect" className="form-label d-block mb-2">
                                                    Shipment Type
                                                </Label>
                                                <Input
                                                    type="select"
                                                    id="shipmentTypeSelect"
                                                    name="shipmentType"
                                                    className="text-center"
                                                    value={formState.ShipmentType}
                                                    onChange={(e: any) => handleInputChange({ ShipmentType: e.target.value })}
                                                    style={{ margin: '0 auto', maxWidth: '500px' }}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="out">Out</option>
                                                    <option value="in">In</option>
                                                </Input>
                                            </Col>

                                        )}
                                    </Row>
                                </div>
                            </Form>
                        </TabPane>

                        <TabPane tabId={3}>
                            <div>
                                <div className="text-center mb-4">
                                    <h5>Body Report POD</h5>
                                    <p className="card-title-desc">
                                        In this section you can configure the fields that are displayed in the body of the report.
                                    </p>
                                </div>
                                <TableConfigFields
                                    ArrayFields={formState.ArrayBody}
                                    handleInputChange={(updatedArrayBody) => handleInputChange({ ArrayBody: updatedArrayBody })}
                                />
                            </div>
                        </TabPane>
                        <TabPane tabId={4}>
                            <div>
                                <div className="text-center mb-4">
                                    <h5>Table Report POD</h5>
                                    <p className="card-title-desc">
                                        In this section you can configure the columns that are displayed in the report table.
                                    </p>
                                </div>
                                <TableConfigFields
                                    ArrayFields={formState.ArrayTable}
                                    handleInputChange={(updatedArrayTable) => handleInputChange({ ArrayTable: updatedArrayTable })}
                                />
                            </div>
                        </TabPane>
                        <TabPane tabId={5}>
                            <div>
                                <div className="text-center mb-4">
                                    <h5>Footer Report POD</h5>
                                    <p className="card-title-desc">
                                        In this section you can configure the footer that is displayed in the last part of the report.
                                    </p>
                                </div>
                                <FormGroup>
                                    <Label for="footerText">Footer Text</Label>
                                    <Input
                                        type="textarea"
                                        id="footerText"
                                        name="footerText"
                                        value={formState.Footer}
                                        onChange={(e: any) => {
                                            const value = e.target.value;
                                            const escapedValue = value.replace(/\n/g, '\\n'); // Si quieres escapar los saltos de línea
                                            handleInputChange({ Footer: escapedValue });
                                        }}
                                        rows={5}
                                        placeholder="Write your footer text here..."
                                    />
                                </FormGroup>
                            </div>
                        </TabPane>
                        <TabPane tabId={6}>
                            <div>
                                <div className="text-center mb-4">
                                    <h5>Preview Report POD</h5>
                                    <p className="card-title-desc">
                                        In this section you can preview the report according to the POD configuration.
                                    </p>
                                    <Button className="save-button-POD" onClick={handleSaveConfig}>
                                        <i className="dripicons-checkmark"></i> Save
                                    </Button>
                                </div>
                                <PreviewTemplate formState={formState} />
                            </div>
                        </TabPane>
                    </TabContent>
                    {activeTab !== 1 && (
                        <ul className="pager wizard twitter-bs-wizard-pager-link mb-4">
                            <li className={activeTab === 1 ? 'previous disabled' : 'previous'}>
                                <Link
                                    to="#"
                                    className={'btn button-primaryColor'}
                                    onClick={() => {
                                        toggleTab(activeTab - 1);
                                    }}
                                >
                                    <i className="bx bx-chevron-left me-1"></i> Previous
                                </Link>
                            </li>

                            <li className={activeTab === 6 ? 'next disabled' : 'next'}>
                                <Link
                                    to="#"
                                    className={activeTab === 6 ? 'btn disabled button-primaryColor' : 'btn button-primaryColor'}
                                    onClick={() => {
                                        toggleTab(activeTab + 1);
                                    }}
                                >
                                    Next <i className="bx bx-chevron-right ms-1"></i>
                                </Link>
                            </li>
                        </ul>
                    )}
                </div>
            </CardBody>
        </React.Fragment>
    );
};

export default ConfigReportPODForm;
